// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SmallTalkBotSays__smallTalkBotSays___1Qax1{width:50%;min-width:50%;box-sizing:border-box;overflow-y:auto}.SmallTalkBotSays__smallTalkBotSaysHeader___2LLrv{display:flex;align-items:center;font-size:12px;color:#777;margin-bottom:16px;padding:16px;padding-bottom:0}.SmallTalkBotSays__smallTalkBotSaysHeaderIcon___3a1-D{width:24px;height:24px;margin-right:8px;margin-left:-2px;opacity:0.5}.SmallTalkBotSays__smallTalkBotSaysBody___2TwPn{flex:1;padding:16px}\n", ""]);
// Exports
exports.locals = {
	"smallTalkBotSays": "SmallTalkBotSays__smallTalkBotSays___1Qax1",
	"smallTalkBotSaysHeader": "SmallTalkBotSays__smallTalkBotSaysHeader___2LLrv",
	"smallTalkBotSaysHeaderIcon": "SmallTalkBotSays__smallTalkBotSaysHeaderIcon___3a1-D",
	"smallTalkBotSaysBody": "SmallTalkBotSays__smallTalkBotSaysBody___2TwPn"
};
module.exports = exports;
